import {createTheme} from '@mui/material';
import colors from './colors';

const theme = createTheme({
  palette: colors,
  components: {
    MuiListItem: {
      styleOverrides: {
        root: {
          color: 'rgba(0, 0, 0, 0.54)',
          '&.Mui-selected': {
            backgroundColor: 'rgba(0, 0, 0, 0.54)',
            color: '#fff',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.54)',
              color: '#fff',
            },
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          padding: '8px 24px',
          minHeight: '40px',
        },
      },
    },
  },
});

export default theme;
